<div #overlay class="confirm-overlay" [ngStyle]="style">
    <div class="confirm-content">
        <div>
            <h2 data-cy="leave-dialog-label">
                {{ "general.leave-page-prompt-1" | translate }}<br />
                {{ "general.leave-page-prompt-2" | translate }}
            </h2>
            <div class="window-button-container window-button-margin">
                <button
                data-cy="leave-dialog-cancel-button"
                    class="window-button component-large button-stay-color"
                    (click)="emitValue(false)"
                >
                    {{ "general.leave-page-option-stay" | translate }}
                </button>
                <button
                data-cy="leave-dialog-confirm-button"
                    class="window-button component-large button-leave-color"
                    (click)="emitValue(true)"
                >
                    {{ "general.leave-page-option-leave" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
